import { createFileRoute } from "@tanstack/react-router"

import { GuidePage } from "../../components/landing"
import { rateGuideZh } from "../../content/zh/cents-per-km-calculator"
import { guideSeo } from "../guides.$slug"

const PATH = "/cents-per-km-calculator"

/** Chinese version of /cents-per-km-calculator (D-WEB-LANG-SCOPE, T1320); the English route carries the hreflang pair too. */
export const centsPerKmZhSeo = () => guideSeo(rateGuideZh, PATH, "zh")

export const Route = createFileRoute("/_brand-layout/zh/cents-per-km-calculator")({
  head: () => {
    const { meta, links, scripts } = centsPerKmZhSeo()
    return { meta, links, scripts }
  },
  component: CentsPerKmZhPage,
})

export function CentsPerKmZhPage() {
  return <GuidePage guide={rateGuideZh} />
}
